import type { MeasuredRollout } from '@gonfalon/measured-rollouts/types';
import type { Metric } from '@gonfalon/metrics/types';

import type { DifferenceEstimateType } from '../types';

/**
 * Gets the difference estimate type (relative or absolute) for a metric.
 * Defaults to 'relative' if not found or not set.
 *
 * @param measuredRollout - The measured rollout containing design configuration
 * @param metric - The metric to get the difference estimate type for
 * @returns The difference estimate type ('relative' or 'absolute')
 */
export function getDifferenceEstimateType(measuredRollout: MeasuredRollout, metric: Metric): DifferenceEstimateType {
  const metricControl = measuredRollout.design.metricControls?.find((m) => m.metricKey === metric.key);
  return metricControl?.differenceEstimateType ?? 'relative';
}
